(function () {
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "${{amount}}";

    function defaultOption(opt, def) {
      return opt == null ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + thousands),
        cents2 = parts[1] ? decimal + parts[1] : "";
      return dollars + cents2;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector(".ds-builder");
    if (!root) return;

    var moneyFormat = root.dataset.moneyFormat || "${{amount}}";
    var qtyInputs = Array.prototype.slice.call(root.querySelectorAll("[data-ds-qty-input]"));
    var countEl = document.getElementById("ds-count");
    var totalEl = document.getElementById("ds-total");
    var boxNoteEl = document.getElementById("ds-box-note");
    var boxNoteBaseText = boxNoteEl.textContent.trim();
    var addBtn = document.getElementById("ds-add-to-cart");
    var errorEl = document.getElementById("ds-error");
    var successEl = document.getElementById("ds-success");
    var shortageBanner = document.getElementById("ds-shortage-banner");
    var addBtnBaseText = addBtn.textContent.trim();
    var successTimeout = null;

    // The header cart icon count is rendered server-side at page load. Since
    // we add to cart via our own fetch calls instead of the theme's normal
    // cart form, nothing else updates it — patch it directly so the count
    // stays accurate without navigating away or reloading the page.
    function updateCartIconCount(itemCount) {
      var bubbleCount = document.querySelector('[data-testid="cart-bubble"]');
      if (bubbleCount) bubbleCount.textContent = itemCount;
      var cartIcon = document.querySelector("cart-icon");
      if (cartIcon) {
        cartIcon.classList.toggle("header-actions__cart-icon--has-cart", itemCount > 0);
      }
    }

    function showSuccessMessage(count) {
      successEl.innerHTML =
        "Added " + count + " item" + (count === 1 ? "" : "s") + ' to your cart. <a href="/cart">View cart →</a>';
      if (successTimeout) clearTimeout(successTimeout);
      successTimeout = setTimeout(function () {
        successEl.textContent = "";
      }, 6000);
    }

    // How many 10ML items are already sitting in the cart (e.g. added from a
    // product page, or a previous visit). The sitewide sticky bar tracks this
    // number, so the on-page progress note needs to start from the same
    // baseline — otherwise the two can show different, contradicting counts.
    var cartBaseQty = 0;

    function fetchCartBaseQty() {
      return fetch("/cart.js")
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var qty = 0;
          cart.items.forEach(function (item) {
            var title = (item.variant_title || "").toUpperCase();
            if (title.indexOf("10ML") !== -1) qty += item.quantity;
          });
          cartBaseQty = qty;
        })
        .catch(function () {
          cartBaseQty = 0;
        });
    }

    function getAvailableQty(input) {
      var n = parseInt(input.dataset.availableQty, 10);
      return isNaN(n) ? 999999 : n;
    }

    function getQty(input) {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      return Math.min(n, getAvailableQty(input));
    }

    function stockNoteFor(input) {
      var card = input.closest("[data-ds-card]");
      return card ? card.querySelector("[data-ds-stock-note]") : null;
    }

    // Show real inventory upfront for low-stock fragrances, rather than only
    // surfacing it once someone hits the ceiling. "Out of stock" is already
    // shown elsewhere for 0, so this only covers the 1-4 range.
    function lowStockNote(available) {
      return "Only " + available + " left in stock";
    }

    function updateStockNote(input) {
      var note = stockNoteFor(input);
      if (!note) return;
      var available = getAvailableQty(input);
      note.textContent = available > 0 && available < 5 ? lowStockNote(available) : "";
    }

    function setQty(input, qty, opts) {
      opts = opts || {};
      var available = getAvailableQty(input);
      var clamped = Math.max(0, Math.min(qty || 0, available));
      input.value = clamped;

      var note = stockNoteFor(input);
      if (note) {
        if (qty > available && available < 999999) {
          note.textContent = lowStockNote(available);
        } else if (available > 0 && available < 5) {
          // Keep the low-stock count visible while the shopper is adjusting
          // quantity, not just when they overshoot it.
          note.textContent = lowStockNote(available);
        } else if (!opts.keepNote) {
          note.textContent = "";
        }
      }

      var card = input.closest("[data-ds-card]");
      if (card) card.classList.toggle("ds-card--active", clamped > 0);
      recalc();
    }

    function recalc() {
      var count = 0;
      var totalCents = 0;

      qtyInputs.forEach(function (input) {
        var qty = getQty(input);
        count += qty;
        totalCents += Math.round(parseFloat(input.dataset.price) * 100) * qty;
      });

      countEl.textContent = count;
      totalEl.textContent = formatMoney(totalCents, moneyFormat);
      updateBoxNote(count);

      addBtn.disabled = count === 0;
      return count;
    }

    function updateBoxNote(selectedCount) {
      // Combine what's already in the cart with what's currently selected
      // here (but not yet added), so this note and the sitewide sticky bar
      // always agree — the bar reflects the cart as it is now; this reflects
      // what the cart will become once the current selection is added.
      var combined = cartBaseQty + selectedCount;
      var freeBoxes = Math.floor(combined / 4);
      var remainder = combined % 4;

      if (combined === 0) {
        boxNoteEl.textContent = boxNoteBaseText;
        boxNoteEl.classList.remove("is-unlocked");
        return;
      }

      var boxesLabel = freeBoxes === 1 ? "1 free carry box" : freeBoxes + " free carry boxes";

      // Precisely distinguish what's already in the cart from what's
      // selected here but not yet added, so the copy never blurs the two
      // together — e.g. "2 in cart, plus 2 selected" rather than a single
      // ambiguous number.
      var haveText;
      if (selectedCount > 0 && cartBaseQty > 0) {
        haveText =
          "You have " +
          cartBaseQty +
          " " +
          (cartBaseQty === 1 ? "bottle" : "bottles") +
          " of 10ML in your cart, plus " +
          selectedCount +
          " more selected here";
      } else if (selectedCount > 0) {
        haveText =
          "You have " + selectedCount + " " + (selectedCount === 1 ? "bottle" : "bottles") + " of 10ML selected";
      } else {
        haveText =
          "You have " + cartBaseQty + " " + (cartBaseQty === 1 ? "bottle" : "bottles") + " of 10ML in your cart";
      }

      if (remainder === 0) {
        boxNoteEl.textContent = haveText + " — that's " + boxesLabel + "!";
        boxNoteEl.classList.add("is-unlocked");
        return;
      }

      var needed = 4 - remainder;
      var neededLabel = needed === 1 ? "1 more 10ML bottle" : needed + " more 10ML bottles";
      var earnPhrase = freeBoxes > 0 ? "earn another free carry box" : "earn a free carry box";

      boxNoteEl.textContent = haveText + ". Add " + neededLabel + " to " + earnPhrase + ".";
      boxNoteEl.classList.remove("is-unlocked");
    }

    root.querySelectorAll("[data-ds-decrement]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var input = btn.parentElement.querySelector("[data-ds-qty-input]");
        setQty(input, getQty(input) - 1);
      });
    });

    root.querySelectorAll("[data-ds-increment]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var input = btn.parentElement.querySelector("[data-ds-qty-input]");
        setQty(input, getQty(input) + 1);
      });
    });

    qtyInputs.forEach(function (input) {
      input.addEventListener("input", function () {
        setQty(input, parseInt(input.value, 10));
      });
      input.addEventListener("blur", function () {
        setQty(input, getQty(input));
      });
    });

    // Surface low-stock counts immediately on page load, not just once
    // someone tries to over-select.
    qtyInputs.forEach(updateStockNote);

    function showShortageBanner(shortages, totalTenMlInCart) {
      if (shortages.length === 0) {
        shortageBanner.hidden = true;
        shortageBanner.innerHTML = "";
        return;
      }

      var lines = shortages
        .map(function (s) {
          return s.title + ": only " + s.available + (s.available === 1 ? " is" : " are") + " available (you asked for " + s.requested + ").";
        })
        .join("<br>");

      var remainder = totalTenMlInCart % 4;
      var recommendation;
      if (totalTenMlInCart === 0) {
        recommendation = "Pick some in-stock fragrances to start a set.";
      } else if (remainder === 0) {
        recommendation = "Your cart is still a full multiple of 4, so your free carry box is unaffected.";
      } else {
        var needed = 4 - remainder;
        recommendation =
          "Add " +
          needed +
          " more of another in-stock fragrance to complete a full set of 4 and earn your free carry box.";
      }

      shortageBanner.innerHTML =
        "<strong>Some items had less stock than requested — we adjusted your cart:</strong>" +
        lines +
        "<br><br>" +
        recommendation;
      shortageBanner.hidden = false;
    }

    addBtn.addEventListener("click", function () {
      var toAdd = [];
      qtyInputs.forEach(function (input) {
        var qty = getQty(input);
        if (qty > 0) {
          toAdd.push({
            variantId: parseInt(input.dataset.variantId, 10),
            title: input.dataset.title,
            requested: qty,
            input: input,
          });
        }
      });

      if (toAdd.length === 0) return;

      errorEl.textContent = "";
      successEl.textContent = "";
      shortageBanner.hidden = true;
      addBtn.disabled = true;
      addBtn.textContent = "Adding…";

      var shortages = [];
      var anyAdded = false;
      var requestedTotal = toAdd.reduce(function (sum, entry) {
        return sum + entry.requested;
      }, 0);

      // Add each fragrance as its own request. Shopify enforces true, live
      // inventory at this point regardless of what the page loaded with, and
      // — even though it returns an error status when it can't fulfil the
      // full quantity — it still adds what it can and tells us exactly how
      // many, which lets us report the shortfall precisely per fragrance.
      var chain = toAdd.reduce(function (promise, entry) {
        return promise.then(function () {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id: entry.variantId, quantity: entry.requested }] }),
          })
            .then(function (res) {
              return res.json().then(function (data) {
                return { res: res, data: data };
              });
            })
            .then(function (result) {
              if (result.res.ok) {
                anyAdded = true;
                return;
              }
              var text = result.data.message || result.data.description || "";
              var match = /Only (\d+) item/i.exec(text);
              var added = match ? parseInt(match[1], 10) : 0;
              if (added > 0) anyAdded = true;
              shortages.push({ title: entry.title, requested: entry.requested, available: added });
              // The live inventory Shopify just reported is more authoritative
              // than whatever the page loaded with — reflect it immediately.
              entry.input.dataset.availableQty = added;
              updateStockNote(entry.input);
            })
            .catch(function () {
              shortages.push({ title: entry.title, requested: entry.requested, available: 0 });
            });
        });
      }, Promise.resolve());

      chain
        .then(function () {
          return fetch("/cart.js").then(function (res) {
            return res.json();
          });
        })
        .then(function (cart) {
          var totalTenMlInCart = 0;
          cart.items.forEach(function (item) {
            var title = (item.variant_title || "").toUpperCase();
            if (title.indexOf("10ML") !== -1) totalTenMlInCart += item.quantity;
          });

          // Whatever just got added (fully or partially) is now part of the
          // cart, so it becomes the new baseline — reset the pending
          // selection to 0 rather than leaving it showing, which would
          // otherwise double-count those items against the cart total.
          cartBaseQty = totalTenMlInCart;
          toAdd.forEach(function (entry) {
            setQty(entry.input, 0, { keepNote: true });
          });

          recalc();
          showShortageBanner(shortages, totalTenMlInCart);
          updateCartIconCount(cart.item_count);

          // Stay on the page rather than redirecting to /cart — just confirm
          // what was added so the customer can keep building their set.
          addBtn.disabled = false;
          addBtn.textContent = addBtnBaseText;

          if (shortages.length > 0) {
            // Shortage banner above already explains the correction.
          } else if (anyAdded) {
            showSuccessMessage(requestedTotal);
          } else {
            errorEl.textContent = "Could not add those items to your cart.";
          }
        })
        .catch(function (err) {
          errorEl.textContent = err.message || "Could not add to cart.";
          addBtn.disabled = false;
          addBtn.textContent = addBtnBaseText;
        });
    });

    // Get the cart's current 10ML total before the first paint, so the
    // progress note never briefly shows a number that ignores the cart.
    fetchCartBaseQty().then(recalc);
  });
})();
